interface Breadcrumb {
  label: string;
  href?: string;
}

const ROUTE_LABELS: Record<string, string> = {
  dashboard: "Dashboard",
  "identity-providers": "Identity Providers",
  connectors: "Connectors",
  pipelines: "Pipelines",
  "data-catalog": "Data Catalog",
  "policy-studio": "Policy Studio",
  "access-simulator": "Access Simulator",
  "answer-synthesis": "Answer Synthesis",
  "audit-log": "Audit Logs",
  "usage-billing": "Usage & Billing",
  relationships: "Relationships",
  settings: "Settings",
  "api-keys": "API Keys",
  organization: "Organization",
};

export function useBreadcrumbs(pathname: string): Breadcrumb[] {
  const segments = pathname.split("/").filter(Boolean);
  if (segments.length === 0) return [];

  const crumbs: Breadcrumb[] = [];
  let currentPath = "";

  for (let i = 0; i < segments.length; i++) {
    const segment = segments[i];
    currentPath += `/${segment}`;
    const label = ROUTE_LABELS[segment] ?? segment.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
    const isLast = i === segments.length - 1;
    crumbs.push({ label, href: isLast ? undefined : currentPath });
  }

  return crumbs;
}
